import Components from './components/index.js';

Components.install();
